module.exports = __webpack_public_path__ + "images/team/team-mykola.png";